import { select } from '@ngneat/elf';

import { maintenanceStore } from './maintenance.store';

export const maintenanceSelector = {
	status$: maintenanceStore.pipe(select((state) => state)),
	isInMaintenance$: maintenanceStore.pipe(select((state) => state.enabled)),
};
